import { render, staticRenderFns } from "./newBotPostEmpty.vue?vue&type=template&id=13a202f5&"
import script from "./newBotPostEmpty.vue?vue&type=script&lang=js&"
export * from "./newBotPostEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports